import {React, useState} from "react";
import './AlbumGrid.css';
import AlbumCard from "./AlbumCard";
import { useApi } from "../../hooks/useApi";
import { fetchAlbums } from "../../api/albums";
import { LoadingBox } from "../../components/LoadingBox";
import he from 'he';


const AlbumGrid = () => {
  const { output: albums, loading, error } = useApi(fetchAlbums);


  if (loading) { 
    return (
      <div className="loading-wrapper">
        <LoadingBox/>
      </div>
    )
  }

  if (error){ 
    <div>
      Error: {error}
    </div>   
  }

  return(
    <div className="album-grid">
      {albums.map((album) =>(
        <AlbumCard 
          key = {album.id}
          frontImageId ={album.acf.front_image}
          rearImageId = {album.acf.rear_image}
          albumTitle = {he.decode(album.title.rendered)}
          artistName = {album.acf.artist_name}
          role = {album.acf.role}
          blurb = {album.acf.blurb}
          albumUrl = {album.acf.album_url.url}
          albumUrlText= {album.acf.album_url.title}
        />
      ))}
    </div>
  );

  
}

export default AlbumGrid;
